import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { UiNotificationService } from 'src/app/external-ui-shared/services/ui-notification.service';
import { DocumentService } from 'src/app/feature-module/documents/service/document.service';
import { FormUtilsService } from 'src/app/shared/services/form-utils.service';
import { ProofDocument, ProofDocumentFormBuilder } from '../../models/ProofDocument';

@Component({
  selector: 'app-manage-proof-document',
  templateUrl: './manage-proof-document.component.html',
  styleUrls: ['./manage-proof-document.component.scss']
})
export class ManageProofDocumentComponent extends DialogContentBase implements OnInit {

  constructor(public dialog: DialogRef, private fb: UntypedFormBuilder,
    private documentService: DocumentService,
    private formUtilsService: FormUtilsService, private uiNotification: UiNotificationService) {
    super(dialog);
    }

  addDataForm: UntypedFormGroup;
  addData: ProofDocument;
  error: string;

  editMode: boolean;
  @Input() public inputData: any;
  
  ngOnInit(): void {
    this.initForm();
  }

  initForm(): void {

    this.addData = this.inputData;
    this.editMode = (this.addData.id > 0)
    this.addDataForm = ProofDocumentFormBuilder.getForm(this.fb, this.addData);
  }

  cancel() {
    this.dialog.close({ text: 'Cancel' });
  }

  confirm() {

    if(!this.formUtilsService.markFormGroupTouched(this.addDataForm)){
      this.uiNotification.showValidationError();
      return;
    }

    Object.assign(this.addData, this.addDataForm.value);

      this.documentService.storeProofDocument(this.addData).subscribe(
        r => { 
          this.uiNotification.showSuccess('validations.dataStoredSuccesfully');
          this.dialog.close({ text: 'OK' });
         });

    }
  }

